import React from "react";
import omanConfig from "./config/oman.json";
import saConfig from "./config/sa.json";
import statSurveyConfig from "./config/statsurvey.json";

export const tenants = {
    oman: omanConfig,
    sa: saConfig,
    statsurvey: statSurveyConfig,
    localhost: statSurveyConfig
};

export const TenantContext = React.createContext(
    tenants.oman // default value
);



// WEBPACK FOOTER //
// ./src/features/tenant/TenantContex.js